import { DataResponse, PageableResponse, User } from '../models';
import { composeQuery, Query } from '../models/query';
import { k1Axios } from './axios';

export const getUsers = async (...criteria: Query<User>[]) => (
  await k1Axios.get<PageableResponse<User>>('/users', {
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    },
    params: composeQuery<User>(...criteria),
    data: {},
  })
).data;

export const queryUsers = async (...criteria: Query<User>[]) => (
  await k1Axios.get<PageableResponse<User>>('/users/query', {
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    },
    params: composeQuery<User>(...criteria),
    data: {},
  })
).data;

export const checkAdminCreated = async () => (
  await k1Axios.get<DataResponse<User>>('/users/user-created', {
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    },
  })
).data;

export const forgotPassword = async (input: Required<Pick<User, 'email'>>) => (await k1Axios.post('/users/forgot-password', input)).data;

export const resetPassword = async (
  input: Required<Pick<User, 'password' | 'resetPasswordCode'>>,
) => (await k1Axios.post('/users/reset-password', input)).data;
